import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown, LogOut, LayoutDashboard, GraduationCap, User as UserIcon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/", label: "Anasayfa" },
  { to: "/egitimler", label: "Eğitimler" },
  { to: "/kurumsal-cozumler", label: "Kurumsal Çözümler" },
  { to: "/egitmen", label: "Eğitmen" },
  { to: "/blog", label: "Blog" },
  { to: "/iletisim", label: "İletişim" },
  { to: "/kayit-formu", label: "Kayıt Formu" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/80 border-b border-white/10"
    >
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="relative">
            <div className="w-10 h-10 border border-gold-30 flex items-center justify-center">
              <span className="font-display text-gold text-lg">ZB</span>
            </div>
            <div className="absolute inset-0 gold-shimmer opacity-0 group-hover:opacity-30 pointer-events-none" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-white text-xl tracking-tight">ZB Campus</div>
            <div className="text-[10px] uppercase tracking-[0.32em] text-gold">Muhasebe Akademisi</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive ? "text-gold" : "text-white/80 hover:text-gold"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-btn" className="btn-outline text-sm py-2 px-4">
              <LayoutDashboard className="w-4 h-4" /> Yönetim
            </Link>
          )}
          {user && user !== false && (
            <Link to="/egitimlerim" data-testid="nav-my-courses-btn" className="btn-outline text-sm py-2 px-4">
              <GraduationCap className="w-4 h-4" /> Eğitimlerim
            </Link>
          )}
          {user && user !== false ? (
            <>
              <span className="text-xs text-white/60 hidden xl:inline">Merhaba, {user.name.split(" ")[0]}</span>
              <button
                data-testid="nav-logout-btn"
                onClick={handleLogout}
                className="btn-outline text-sm py-2 px-4"
              >
                <LogOut className="w-4 h-4" /> Çıkış
              </button>
            </>
          ) : (
            <>
              <Link to="/giris" data-testid="nav-login-btn" className="text-sm text-white/80 hover:text-gold">
                Giriş
              </Link>
              <Link to="/kayit" data-testid="nav-register-btn" className="btn-primary text-sm py-2 px-5">
                Kayıt Ol
              </Link>
            </>
          )}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Menü"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl">
          <div className="container-x py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-gold" : "text-white/80"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <div className="hairline my-2" />
            {user && user !== false ? (
              <>
                {user.role === "admin" && (
                  <Link to="/admin" onClick={() => setOpen(false)} className="btn-outline justify-center">
                    <LayoutDashboard className="w-4 h-4" /> Yönetim Paneli
                  </Link>
                )}
                <Link to="/egitimlerim" onClick={() => setOpen(false)} className="btn-outline justify-center">
                  <GraduationCap className="w-4 h-4" /> Eğitimlerim
                </Link>
                <button onClick={handleLogout} className="btn-outline justify-center">
                  <LogOut className="w-4 h-4" /> Çıkış Yap
                </button>
              </>
            ) : (
              <>
                <Link to="/giris" onClick={() => setOpen(false)} className="btn-outline justify-center">
                  Giriş
                </Link>
                <Link to="/kayit" onClick={() => setOpen(false)} className="btn-primary justify-center">
                  Kayıt Ol
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
